<script setup lang="ts">
import { type Icon, isIcon } from '@/types/icon';

const props = defineProps<{
    icon: Icon;
}>();

const icon = computed<Component | undefined>(() => {
    if (!isIcon(props.icon)) {
        useLogger().error(`Icon ${props.icon as string} not found`);
        return;
    }

    return defineAsyncComponent<Component>(async () => import(`@/assets/icons/${props.icon}.svg`));
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
    <component :is="icon" v-if="icon" />
</template>
